import { render, staticRenderFns } from "./Chati.vue?vue&type=template&id=5e94a609"
import script from "./Chati.vue?vue&type=script&lang=js"
export * from "./Chati.vue?vue&type=script&lang=js"
import style0 from "./Chati.vue?vue&type=style&index=0&id=5e94a609&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports